import { useEffect, useRef } from "react";

const AdstraBanner = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const scriptLoadedRef = useRef(false);

  useEffect(() => {
    if (scriptLoadedRef.current) return;
    scriptLoadedRef.current = true;

    // Define atOptions globally
    (window as any).atOptions = {
      'key': '32c2e3d695edbbb608edaa33a557a4ac',
      'format': 'iframe',
      'height': 60,
      'width': 468,
      'params': {}
    };

    // Load the Adsterra script
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = '//www.highperformanceformat.com/32c2e3d695edbbb608edaa33a557a4ac/invoke.js';
    script.async = true;

    if (containerRef.current) {
      containerRef.current.appendChild(script);
    }

    return () => {
      // Cleanup on unmount
      if (containerRef.current && script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="w-full flex justify-center py-4">
      <div ref={containerRef} className="inline-block" />
    </div>
  );
};

export default AdstraBanner;
